// extracted by mini-css-extract-plugin
module.exports = {"page-title-bar":"page-title-bar__page-title-bar___1ns4G","app-flash-banner":"page-title-bar__app-flash-banner___36zvw"};